module.exports = __webpack_public_path__ + "static/img/3.1ed2e4bf.png";